import Interaction from "../../../models/interactions/Interaction";
import {
  IUpdateTimer,
  TimerFunction,
  getTimerFunctionLabel,
  isParametricTimerFunction,
} from "../../../models/interactions/UpdateTimer";
import NodeNumberField from "../components/NodeNumberField";
import NodeStringDropdown from "../components/NodeStringDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function UpdateTimerNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IUpdateTimer;
  const { updateInteraction } = useUpdateSequenceInteraction();
  const selectedFunctionLabel = getTimerFunctionLabel(interaction.function);
  const timerFunctionOptions: TimerFunction[] = [
    TimerFunction.Start,
    TimerFunction.Stop,
    TimerFunction.Reset,
    TimerFunction.SetTime,
    TimerFunction.AddTime,
    TimerFunction.Destroy,
    TimerFunction.Show,
    TimerFunction.Hide,
    TimerFunction.SetSpeed,
    TimerFunction.Loop,
    TimerFunction.ScaledTime,
  ];

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <NodeStringDropdown
        label="Function"
        selectedItem={selectedFunctionLabel}
        items={timerFunctionOptions.map(getTimerFunctionLabel)}
        onClick={(functionLabel) => {
          const selected = timerFunctionOptions.find(
            (opt) => getTimerFunctionLabel(opt) === functionLabel
          );
          if (selected === undefined) return;
          updateInteraction(props.nodeId, {
            ...interaction,
            function: selected,
          } as IUpdateTimer);
        }}
      />
      {isParametricTimerFunction(interaction.function) && (
        <NodeNumberField
          label="Value"
          value={interaction.value}
          onChange={(value) =>
            updateInteraction(props.nodeId, {
              ...interaction,
              value,
            } as IUpdateTimer)
          }
        />
      )}
    </div>
  );
}
